/*
 * @Author: Teemo Ding
 * @Date: 2021-06-22 14:36:30
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 10:44:31
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/DeveloperSetting/AccessKey/index.tsx
 */
import { Button } from '@/src/components/Antd';
import Table from '@/src/components/EditableTable/EditableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import css from './css.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const AccessKey = ({ CreateAccessKey, accessKey, columns, disableCreate }) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      title={getI18n('storeDeveloperSetting.detail.accessKey')}
      className={css.accessKey}>
      <p>{getI18n('storeDeveloperSetting.detail.tip1')}</p>
      <p>{getI18n('storeDeveloperSetting.detail.tip2')}</p>
      {accessKey.length ? (
        <Table
          id='uuid'
          rowKey='uuid'
          className={css.globalTable}
          columns={columns}
          dataSource={accessKey}
        />
      ) : (
        <h3>{getI18n('storeDeveloperSetting.detail.noKey')}.</h3>
      )}
      <Button
        type='primary'
        onClick={() => CreateAccessKey()}
        disabled={disableCreate}>
        {getI18n('storeDeveloperSetting.detail.createAccessKey')}
      </Button>
    </SectionWrapper>
  );
};
export default AccessKey;
